export default __webpack_public_path__ + "static/hero-a7e37418e3d2aa8faf0ac032a898ac5c.png";